import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget } from '@eforall/dashboard';
import { AppService, DomainDataService } from '../../../../../services';
import { EngagementViewerDialogService } from '../engagement-viewer.service';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'engagement-viewer-interactions-part',
	standalone: true,
	imports: [
		GridContentWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './interactions.part.html',
})
export class EngagementViewerInteractionsPart {

	public dialogBodyHeight = input.required<number>();

	private readonly dialog = inject(DialogService);
	private readonly service = inject(EngagementViewerDialogService);
	private util = inject(UtilityService);
	private readonly domainData = inject(DomainDataService);
	private readonly app = inject(AppService);
	public setup = getSetup(this.service, this.util, this.dialog, this.domainData, this.app);

	// subtracting 70 to account for padding and tabstrip
	public customHeight = computed(() => this.dialogBodyHeight() - 70);

	public readonly engagements = computed(() => this.service.engagementDetails()?.contactInteractions.map(e => ({ ...e, updatedUTC: e.contactedDateUTC })) ?? []);

}